import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import {IncidentsComponent} from "./dashboard/incidents/incidents.component";
import {ReportsComponent} from "./dashboard/reports/reports.component";
import {ReportPreviewComponent} from "./shared/report-preview/report-preview.component";
import {EmailComponent} from "./dashboard/email/email.component";
import {DetailChangeHistoryComponent} from "./dashboard/detail/detail-change-history/detail-change-history.component";
import {SettinsPlacesComponent} from "./dashboard/settings/settins-places/settins-places.component";
import {EntryRequestsComponent} from "./entry-requests/entry-requests.component";
import {ViewIncidentRecordComponent} from "./dashboard/incidents/view-incident-record/view-incident-record.component";

const routes: Routes = [
  { path: '', component: AuthLoginComponent, runGuardsAndResolvers: 'always' },
  { path: 'auth', component: AuthLoginComponent, runGuardsAndResolvers: 'always' },
  { path: 'dashboard', component: DashboardComponent, runGuardsAndResolvers: 'always',
    children: [
      {path: '' , component: ReportsComponent},
      {path: 'incidents' , component: IncidentsComponent},
      {path: 'reports' , component: ReportsComponent},
      {path: 'email' , component: EmailComponent},
      {path: 'detail/history' , component: DetailChangeHistoryComponent},
      {path: 'review/:IncidentID/:BatchID' , component: ViewIncidentRecordComponent},
      {path: 'settings/places' , component: SettinsPlacesComponent}
    ]},
  { path: 'request', component: EntryRequestsComponent, runGuardsAndResolvers: 'always' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
    declarations: [

    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
